import { memo, useState } from 'react';

import { QuestionContext } from './QuestionContext';
import { QuestionSearchItem } from '@core/types/types.common';
import { DBQuestion } from '@core/types/types.db';
import { QuestionViewCountEndpoint } from '@core/types/types.endpoint.question';
import { cn } from '@frontend/lib/utils';
import { QuestionEdit } from '@frontend/shared/components/Question/QuestionEdit';
import { QuestionView } from '@frontend/shared/components/Question/QuestionView';
import { useApi } from '@frontend/shared/hooks/shared.hook.useApi';

export interface QuestionProps {
  question: QuestionSearchItem | DBQuestion;
  isExpanded?: boolean;
  isCloseable?: boolean;
  initialEditMode?: boolean;
}

export const Question = memo(function Question({
  question,
  isExpanded,
  isCloseable,
  initialEditMode = false,
}: QuestionProps) {
  const [editMode, setEditMode] = useState<boolean>(initialEditMode);

  useApi<QuestionViewCountEndpoint>(
    '/question/viewCount',
    {
      id: question.id,
    },
    isExpanded,
  );

  return (
    <QuestionContext.Provider value={question}>
      <div
        className={cn(
          'py-0 rounded-lg bg-white',
          isExpanded
            ? 'p-0 border-2 border-[rgba(3,52,38,0.9)]'
            : 'p-px border border-[rgba(3,52,38,0.2)]',
        )}
      >
        {editMode ? (
          <QuestionEdit setEditMode={setEditMode} />
        ) : (
          <QuestionView
            isExpanded={isExpanded}
            setEditMode={setEditMode}
            isCloseable={isCloseable}
          />
        )}
      </div>
    </QuestionContext.Provider>
  );
});
